// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Galeria_GetImagesWithoutThumbnailsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /galeria/get_images_without_thumbnails
 *
 * Returns the set of images that still need thumbnails generated, plus
 * counters describing the rest of the candidate set (already-thumbnailed,
 * missing originals, total in database). Consumed by the admin batch
 * thumbnail-generation tool to drive a progress bar.
 *
 * @see Galeria_model::getImagesWithoutThumbnails() for the source query
 */
import type { Galeria_GetImagesWithoutThumbnailsRow } from './Galeria_GetImagesWithoutThumbnailsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Galeria_GetImagesWithoutThumbnailsResponseDados {
images: Galeria_GetImagesWithoutThumbnailsRow[]
total_needing_thumbnails: number
already_have_thumbnails: number
images_not_found: number
total_in_database: number
}

export type Galeria_GetImagesWithoutThumbnailsResponse = ApiResponse<Galeria_GetImagesWithoutThumbnailsResponseDados>;

registerResponseContract('Galeria_GetImagesWithoutThumbnailsResponse', {
  images: {
    type: 'array',
    required: true,
    items: {
      id:   { type: 'number',  required: true },
      nome: { type: 'string',  required: true },
    },
  },
  total_needing_thumbnails: { type: 'number',  required: true },
  already_have_thumbnails:  { type: 'number',  required: true },
  images_not_found:         { type: 'number',  required: true },
  total_in_database:        { type: 'number',  required: true },
})
